import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { StorageKeys } from 'app/Shared/Constant/StorageKeys';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { AuthServiceService } from './auth-service.service';

@Injectable(
	{providedIn: 'root'}
)
export class AdminAuthguardGuard implements CanActivate {
	constructor(private authServiceService: AuthServiceService,
		private constantService: ConstantService,
		private messageService: MessageService,
		private userService: UserService,
		private router: Router) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.authServiceService.getUserLoggedIn() === true || this.constantService.getSessionStorage(StorageKeys.User)) {
			let canFirmAccessURL = this.verifyFirmAccessibility(next);
			return canFirmAccessURL;
		}
	 	return false;
	}

	/* Check Firm User Accessibility for Menu OR Submenu Screen */
	verifyFirmAccessibility(urlRouteParams: any) {
		console.log(!this.userService.isRoleSuperUser())
		if(!this.userService.isRoleSuperUser()) {
				this.messageService.add({ severity: 'error', summary: "Service Access", detail: (urlRouteParams.routeConfig.path + " service not available.") });
				return false;
		}
		return true;
	}

}